import pick from '@tinkoff/utils/object/pick';

import type {Props} from './types';
import {DATE_TIME_TYPES} from './constants';

export function filterTextInputDomProps(props: Props) {
    if (props.type && DATE_TIME_TYPES.indexOf(props.type) !== -1) {
        return pick(['min', 'max'], props);
    }

    return {};
}
